export default __webpack_public_path__ + "static/offering1-cef90f3437908c0d2c7cf41cc572f3f7.png";